import { setCookieValue } from '@do/seashell/utils';
import URLSearchParams from '@ungap/url-search-params';

export const getRefcode = (
  search: string = window.location.search
): string | null => {
  const queryParams = new URLSearchParams(search);
  const redirectURL = queryParams.get('redirect_url');
  if (redirectURL) {
    const redirectQueryParams = new URLSearchParams(redirectURL);
    return redirectQueryParams.get('refcode');
  }
  return null;
};

export const getRegisterRefcode = (
  search: string = window.location.search
): string | null => {
  const queryParams = new URLSearchParams(search);
  const refcode = queryParams.get('refcode');
  return refcode ?? null;
};

export const setRegisterCookie = (refcode: string | null): void => {
  if (refcode) {
    setCookieValue('refcode', refcode);
  }
};
